export enum ETipoConstatacaoQuestao {
  Negativa = 1,
  Neutra = 2,
  Positiva = 3
}

export const ETipoConstatacaoQuestaoDescricao = {
  [ETipoConstatacaoQuestao.Negativa]: 'Negativa',
  [ETipoConstatacaoQuestao.Neutra]: 'Neutra',
  [ETipoConstatacaoQuestao.Positiva]: 'Positiva'
};